import React, {createContext, useContext, useState} from "react";
import API from "../../api/api";

const UserSettingsContext = createContext(null);

export const useUserSettingsContext = () => useContext(UserSettingsContext);

export function UserSettingsProvider({ children }) {
    const [settings, setSettings] = useState(SETTINGS ?? null);

    async function reload() {
        const newSettings = API.get('session/settings/');
        setSettings(newSettings);
    }

    async function update(newSettings) {
        const newServerSettings = API.put('session/settings/update', newSettings);
        setSettings(newServerSettings);
    }

    return <UserSettingsContext.Provider value={{
        settings,
        reload,
        update,
    }}>
        {children}
    </UserSettingsContext.Provider>
}
